import { z } from 'zod';

import type { RelativeDateRangeConfig } from './types';

export const ScheduleTypeSchema = z.enum(['predefined', 'custom']);
export type ScheduleType = z.infer<typeof ScheduleTypeSchema>;

export const ScheduleFrequencySchema = z.enum(['daily', 'weekly', 'monthly']);
export type ScheduleFrequency = z.infer<typeof ScheduleFrequencySchema>;

export const RelativeDateUnitSchema = z.enum(['days', 'weeks', 'months']);
export type RelativeDateUnit = z.infer<typeof RelativeDateUnitSchema>;

/** Day of week 1–7 (Monday–Sunday) for API */
export const SCHEDULE_DAYS_OF_WEEK: { value: number; label: string }[] = [
  { value: 1, label: 'Monday' },
  { value: 2, label: 'Tuesday' },
  { value: 3, label: 'Wednesday' },
  { value: 4, label: 'Thursday' },
  { value: 5, label: 'Friday' },
  { value: 6, label: 'Saturday' },
  { value: 7, label: 'Sunday' },
];

export const SCHEDULE_FREQUENCIES: { value: ScheduleFrequency; label: string }[] = [
  { value: 'daily', label: 'Daily' },
  { value: 'weekly', label: 'Weekly' },
  { value: 'monthly', label: 'Monthly' },
];

export const SCHEDULE_RELATIVE_UNITS: { value: RelativeDateRangeConfig['unit']; label: string }[] = [
  { value: 'days', label: 'Days' },
  { value: 'weeks', label: 'Weeks' },
  { value: 'months', label: 'Months' },
];
